import {useCallback} from 'react'

import {currencySymbolSelector} from '../../../../data/company.js'
import {
  customsLineSelector,
  customsLineErrorsSelector,
  customsLineWarningsSelector,
  maxLinesSelector,
  updateCustomsLine,
  removeCustomsLine,
} from '../../../../data/labelInfos/index.js'
import {useSelector} from '../../../../store.js'
import className from '../../../../common/className.js'
import Zelect from '../../../../common/components/Zelect.js'
import Icon from '../../../../common/icons/Icon.js'

export default function Line({
  index,
  labelInfoID,
  customsInfoIndex,
  canHaveHarmonizationCode,
  canHaveHarmonizationCodeCountry,
  canHaveSKU,
  showEUPIDs,
  unitOfMeasureOptions,
}) {
  const {
    description,
    quantity,
    weightLB,
    weightOZ,
    value,
    sku,
    harmonizationCode,
    harmonizationCodeCountry,
    country,
    m_pid,
    ns_pid,
    s_pid,
    ...line
  } = useSelector((state) =>
    customsLineSelector(state, {labelInfoID, customsInfoIndex}),
  )
  const currencySymbol = useSelector((state) => currencySymbolSelector(state))
  const errors = useSelector((state) =>
    customsLineErrorsSelector(state, {
      labelInfoID,
      customsInfoIndex,
    }),
  )
  const warnings = useSelector((state) =>
    customsLineWarningsSelector(state, {
      labelInfoID,
      customsInfoIndex,
    }),
  )
  const maxLines = useSelector((state) =>
    maxLinesSelector(state, {labelInfoID}),
  )

  const update = useCallback(
    (updates) => updateCustomsLine(labelInfoID, customsInfoIndex, updates),
    [labelInfoID, customsInfoIndex],
  )

  return (
    <tr
      className={className`${{'tr--error': customsInfoIndex + 1 > maxLines}}`}
    >
      <td className="table__td">
        <textarea
          className="textarea textarea--customs margin-bottom-0"
          value={description}
          onChange={(event) => update({description: event.target.value})}
        />
        {errors.description && (
          <small className="error error-message">{errors.description}</small>
        )}
        {warnings.description && (
          <small className="error error-message">{warnings.description}</small>
        )}
      </td>
      <td className="table__td">
        <input
          type="text"
          className="input--text input--x-sm margin-bottom-0"
          value={quantity}
          onChange={(event) => update({quantity: event.target.value})}
        />
        {errors.quantity && (
          <small className="error error-message">{errors.quantity}</small>
        )}
      </td>
      {unitOfMeasureOptions.length > 0 && (
        <td className="table__td wrap--btn-text-sm">
          <Zelect
            buttonClassName="w-100"
            id={`customs_unit_of_measure_${index}`}
            value={line.unit_of_measure || ''}
            onChange={(option) => update({unit_of_measure: option.value})}
            options={unitOfMeasureOptions}
            placeholder="Select one..."
            hideDisabled
            addEmptyOption
            errorMessage={errors.unit_of_measure}
          />
        </td>
      )}
      <td className="table__td">
        <input
          type="text"
          className="input--text input--x-sm make-inline-block margin-bottom-7"
          value={weightLB}
          onChange={(event) => update({weightLB: event.target.value})}
          onBlur={() => {
            if (!weightLB) {
              update({weightLB: '0'})
            }
          }}
        />{' '}
        <span className="inline-block fs-n1 margin-right-10">lb</span>
        <input
          type="text"
          className="input--text input--x-sm make-inline-block margin-bottom-7"
          value={weightOZ}
          onChange={(event) => update({weightOZ: event.target.value})}
          onBlur={() => {
            if (!weightOZ) {
              update({weightOZ: '0'})
            }
          }}
        />{' '}
        <span className="inline-block fs-n1">oz</span>
        {errors.weight && (
          <small className="error error-message">{errors.weight}</small>
        )}
      </td>
      <td className="table__td">
        <strong className="inline-block fs-n1 margin-right-3">
          {currencySymbol}
        </strong>
        <input
          type="text"
          className="input--text input--x-sm make-inline-block margin-bottom-0"
          value={value}
          onChange={(event) => update({value: event.target.value})}
        />
        {errors.value && (
          <small className="error error-message">{errors.value}</small>
        )}
      </td>
      {canHaveSKU && (
        <td className="table__td">
          <input
            type="text"
            className="input--text input--md make-inline-block margin-bottom-0"
            value={sku}
            onChange={(event) => update({sku: event.target.value})}
          />
          {errors.sku && (
            <small className="error error-message">{errors.sku}</small>
          )}
        </td>
      )}
      {canHaveHarmonizationCode && (
        <td className="table__td">
          <input
            type="text"
            className="input--text input--md make-inline-block margin-bottom-0"
            value={harmonizationCode}
            onChange={(event) =>
              update({harmonizationCode: event.target.value})
            }
          />
          {errors.harmonizationCode && (
            <small className="error error-message">
              {errors.harmonizationCode}
            </small>
          )}
        </td>
      )}
      {canHaveHarmonizationCodeCountry && (
        <td className="table__td">
          <input
            type="text"
            className="input--text input--x-sm make-inline-block margin-bottom-0"
            value={harmonizationCodeCountry}
            onChange={(event) =>
              update({harmonizationCodeCountry: event.target.value})
            }
          />
          {errors.harmonizationCodeCountry && (
            <small className="error error-message">
              {errors.harmonizationCodeCountry}
            </small>
          )}
        </td>
      )}
      {showEUPIDs && (
        <>
          <td className="table__td">
            <input
              type="text"
              className="input--text input--x-sm make-inline-block input--100 margin-bottom-0"
              value={m_pid}
              onChange={(event) => update({m_pid: event.target.value})}
            />
            {errors.m_pid && (
              <small className="error error-message lh-sm">
                {errors.m_pid}
              </small>
            )}
          </td>
          <td className="table__td">
            <input
              type="text"
              className="input--text input--x-sm make-inline-block input--100 margin-bottom-0"
              value={ns_pid}
              onChange={(event) => update({ns_pid: event.target.value})}
            />
            {errors.ns_pid && (
              <small className="error error-message lh-sm">
                {errors.ns_pid}
              </small>
            )}
          </td>
          <td className="table__td">
            <input
              type="text"
              className="input--text input--x-sm make-inline-block input--100 margin-bottom-0"
              value={s_pid}
              onChange={(event) => update({s_pid: event.target.value})}
            />
            {errors.s_pid && (
              <small className="error error-message lh-sm">
                {errors.s_pid}
              </small>
            )}
          </td>
        </>
      )}
      <td className="table__td">
        <input
          type="text"
          className="input--text input--x-sm make-inline-block input--100 margin-bottom-0"
          value={country}
          onChange={(event) => update({country: event.target.value})}
        />
        {errors.country && (
          <small className="error error-message">{errors.country}</small>
        )}
      </td>
      <td className="table__td">
        <button
          className="btn btn--link no-underline"
          type="button"
          title="Remove line from order"
          onClick={() => removeCustomsLine(labelInfoID, customsInfoIndex)}
        >
          <Icon name="trash" className="fs-01" />
        </button>
      </td>
    </tr>
  )
}
